import orderRefs from "api/shows/orders/refs";
import { unpackDocs } from "tools/common/unpackDocs";
import { Query } from "api/firebase";
import Order from "ts/api/order";

type GetListArgs = {
  showId: string;
  limit?: number;
};

const orderRepository = {
  getList: async ({ showId, limit }: GetListArgs) => {
    let query = orderRefs.getCollection({ showId }) as Query<Order>;
    if (limit) {
      query = query.limit(limit);
    }
    return (await query.get()).docs.map(unpackDocs);
  },
  getItem: async (showId: string, orderId: string) => {
    const orderDoc = await orderRefs.getDocument({ showId, orderId }).get();
    if (!orderDoc.exists) {
      return null;
    }
    return unpackDocs(orderDoc);
  },
};

export default orderRepository;
